<!-- Clean layout: no chrome -->
<router-outlet></router-outlet>